export const SURVEY_STATUS = {
  AWAITING_LOGIN: "awaiting_login",
  PENDING: "pending",
  DONE: "done",
};
